export interface CountryCallingCodeOption {
  value: string;
  label: string;
  code: string;
}

export const countryCallingCodeOptions: CountryCallingCodeOption[] = [
  { value: "AF", label: "Afghanistan (+93)", code: "+93" },
  { value: "AL", label: "Albania (+355)", code: "+355" },
  { value: "DZ", label: "Algeria (+213)", code: "+213" },
  { value: "AD", label: "Andorra (+376)", code: "+376" },
  { value: "AO", label: "Angola (+244)", code: "+244" },
  { value: "AG", label: "Antigua and Barbuda (+1)", code: "+1" },
  { value: "AR", label: "Argentina (+54)", code: "+54" },
  { value: "AM", label: "Armenia (+374)", code: "+374" },
  { value: "AU", label: "Australia (+61)", code: "+61" },
  { value: "AT", label: "Austria (+43)", code: "+43" },
  { value: "AZ", label: "Azerbaijan (+994)", code: "+994" },
  { value: "BS", label: "Bahamas (+1)", code: "+1" },
  { value: "BH", label: "Bahrain (+973)", code: "+973" },
  { value: "BD", label: "Bangladesh (+880)", code: "+880" },
  { value: "BB", label: "Barbados (+1)", code: "+1" },
  { value: "BY", label: "Belarus (+375)", code: "+375" },
  { value: "BE", label: "Belgium (+32)", code: "+32" },
  { value: "BZ", label: "Belize (+501)", code: "+501" },
  { value: "BJ", label: "Benin (+229)", code: "+229" },
  { value: "BT", label: "Bhutan (+975)", code: "+975" },
  { value: "BO", label: "Bolivia (+591)", code: "+591" },
  { value: "BA", label: "Bosnia and Herzegovina (+387)", code: "+387" },
  { value: "BW", label: "Botswana (+267)", code: "+267" },
  { value: "BR", label: "Brazil (+55)", code: "+55" },
  { value: "BN", label: "Brunei (+673)", code: "+673" },
  { value: "BG", label: "Bulgaria (+359)", code: "+359" },
  { value: "BF", label: "Burkina Faso (+226)", code: "+226" },
  { value: "BI", label: "Burundi (+257)", code: "+257" },
  { value: "CV", label: "Cabo Verde (+238)", code: "+238" },
  { value: "KH", label: "Cambodia (+855)", code: "+855" },
  { value: "CM", label: "Cameroon (+237)", code: "+237" },
  { value: "CA", label: "Canada (+1)", code: "+1" },
  { value: "CF", label: "Central African Republic (+236)", code: "+236" },
  { value: "TD", label: "Chad (+235)", code: "+235" },
  { value: "CL", label: "Chile (+56)", code: "+56" },
  { value: "CN", label: "China (+86)", code: "+86" },
  { value: "CO", label: "Colombia (+57)", code: "+57" },
  { value: "KM", label: "Comoros (+269)", code: "+269" },
  { value: "CG", label: "Congo (+242)", code: "+242" },
  { value: "CD", label: "Congo (DRC) (+243)", code: "+243" },
  { value: "CR", label: "Costa Rica (+506)", code: "+506" },
  { value: "CI", label: "Cote d'Ivoire (+225)", code: "+225" },
  { value: "HR", label: "Croatia (+385)", code: "+385" },
  { value: "CU", label: "Cuba (+53)", code: "+53" },
  { value: "CY", label: "Cyprus (+357)", code: "+357" },
  { value: "CZ", label: "Czech Republic (+420)", code: "+420" },
  { value: "DK", label: "Denmark (+45)", code: "+45" },
  { value: "DJ", label: "Djibouti (+253)", code: "+253" },
  { value: "DM", label: "Dominica (+1)", code: "+1" },
  { value: "DO", label: "Dominican Republic (+1)", code: "+1" },
  { value: "EC", label: "Ecuador (+593)", code: "+593" },
  { value: "EG", label: "Egypt (+20)", code: "+20" },
  { value: "SV", label: "El Salvador (+503)", code: "+503" },
  { value: "GQ", label: "Equatorial Guinea (+240)", code: "+240" },
  { value: "ER", label: "Eritrea (+291)", code: "+291" },
  { value: "EE", label: "Estonia (+372)", code: "+372" },
  { value: "SZ", label: "Eswatini (+268)", code: "+268" },
  { value: "ET", label: "Ethiopia (+251)", code: "+251" },
  { value: "FJ", label: "Fiji (+679)", code: "+679" },
  { value: "FI", label: "Finland (+358)", code: "+358" },
  { value: "FR", label: "France (+33)", code: "+33" },
  { value: "GA", label: "Gabon (+241)", code: "+241" },
  { value: "GM", label: "Gambia (+220)", code: "+220" },
  { value: "GE", label: "Georgia (+995)", code: "+995" },
  { value: "DE", label: "Germany (+49)", code: "+49" },
  { value: "GH", label: "Ghana (+233)", code: "+233" },
  { value: "GR", label: "Greece (+30)", code: "+30" },
  { value: "GD", label: "Grenada (+1)", code: "+1" },
  { value: "GT", label: "Guatemala (+502)", code: "+502" },
  { value: "GN", label: "Guinea (+224)", code: "+224" },
  { value: "GW", label: "Guinea-Bissau (+245)", code: "+245" },
  { value: "GY", label: "Guyana (+592)", code: "+592" },
  { value: "HT", label: "Haiti (+509)", code: "+509" },
  { value: "HN", label: "Honduras (+504)", code: "+504" },
  { value: "HU", label: "Hungary (+36)", code: "+36" },
  { value: "IS", label: "Iceland (+354)", code: "+354" },
  { value: "IN", label: "India (+91)", code: "+91" },
  { value: "ID", label: "Indonesia (+62)", code: "+62" },
  { value: "IR", label: "Iran (+98)", code: "+98" },
  { value: "IQ", label: "Iraq (+964)", code: "+964" },
  { value: "IE", label: "Ireland (+353)", code: "+353" },
  { value: "IL", label: "Israel (+972)", code: "+972" },
  { value: "IT", label: "Italy (+39)", code: "+39" },
  { value: "JM", label: "Jamaica (+1)", code: "+1" },
  { value: "JP", label: "Japan (+81)", code: "+81" },
  { value: "JO", label: "Jordan (+962)", code: "+962" },
  { value: "KZ", label: "Kazakhstan (+7)", code: "+7" },
  { value: "KE", label: "Kenya (+254)", code: "+254" },
  { value: "KI", label: "Kiribati (+686)", code: "+686" },
  { value: "KP", label: "North Korea (+850)", code: "+850" },
  { value: "KR", label: "South Korea (+82)", code: "+82" },
  { value: "KW", label: "Kuwait (+965)", code: "+965" },
  { value: "KG", label: "Kyrgyzstan (+996)", code: "+996" },
  { value: "LA", label: "Laos (+856)", code: "+856" },
  { value: "LV", label: "Latvia (+371)", code: "+371" },
  { value: "LB", label: "Lebanon (+961)", code: "+961" },
  { value: "LS", label: "Lesotho (+266)", code: "+266" },
  { value: "LR", label: "Liberia (+231)", code: "+231" },
  { value: "LY", label: "Libya (+218)", code: "+218" },
  { value: "LI", label: "Liechtenstein (+423)", code: "+423" },
  { value: "LT", label: "Lithuania (+370)", code: "+370" },
  { value: "LU", label: "Luxembourg (+352)", code: "+352" },
  { value: "MG", label: "Madagascar (+261)", code: "+261" },
  { value: "MW", label: "Malawi (+265)", code: "+265" },
  { value: "MY", label: "Malaysia (+60)", code: "+60" },
  { value: "MV", label: "Maldives (+960)", code: "+960" },
  { value: "ML", label: "Mali (+223)", code: "+223" },
  { value: "MT", label: "Malta (+356)", code: "+356" },
  { value: "MH", label: "Marshall Islands (+692)", code: "+692" },
  { value: "MR", label: "Mauritania (+222)", code: "+222" },
  { value: "MU", label: "Mauritius (+230)", code: "+230" },
  { value: "MX", label: "Mexico (+52)", code: "+52" },
  { value: "FM", label: "Micronesia (+691)", code: "+691" },
  { value: "MD", label: "Moldova (+373)", code: "+373" },
  { value: "MC", label: "Monaco (+377)", code: "+377" },
  { value: "MN", label: "Mongolia (+976)", code: "+976" },
  { value: "ME", label: "Montenegro (+382)", code: "+382" },
  { value: "MA", label: "Morocco (+212)", code: "+212" },
  { value: "MZ", label: "Mozambique (+258)", code: "+258" },
  { value: "MM", label: "Myanmar (+95)", code: "+95" },
  { value: "NA", label: "Namibia (+264)", code: "+264" },
  { value: "NR", label: "Nauru (+674)", code: "+674" },
  { value: "NP", label: "Nepal (+977)", code: "+977" },
  { value: "NL", label: "Netherlands (+31)", code: "+31" },
  { value: "NZ", label: "New Zealand (+64)", code: "+64" },
  { value: "NI", label: "Nicaragua (+505)", code: "+505" },
  { value: "NE", label: "Niger (+227)", code: "+227" },
  { value: "NG", label: "Nigeria (+234)", code: "+234" },
  { value: "MK", label: "North Macedonia (+389)", code: "+389" },
  { value: "NO", label: "Norway (+47)", code: "+47" },
  { value: "OM", label: "Oman (+968)", code: "+968" },
  { value: "PK", label: "Pakistan (+92)", code: "+92" },
  { value: "PW", label: "Palau (+680)", code: "+680" },
  { value: "PS", label: "Palestine (+970)", code: "+970" },
  { value: "PA", label: "Panama (+507)", code: "+507" },
  { value: "PG", label: "Papua New Guinea (+675)", code: "+675" },
  { value: "PY", label: "Paraguay (+595)", code: "+595" },
  { value: "PE", label: "Peru (+51)", code: "+51" },
  { value: "PH", label: "Philippines (+63)", code: "+63" },
  { value: "PL", label: "Poland (+48)", code: "+48" },
  { value: "PT", label: "Portugal (+351)", code: "+351" },
  { value: "QA", label: "Qatar (+974)", code: "+974" },
  { value: "RO", label: "Romania (+40)", code: "+40" },
  { value: "RU", label: "Russia (+7)", code: "+7" },
  { value: "RW", label: "Rwanda (+250)", code: "+250" },
  { value: "KN", label: "Saint Kitts and Nevis (+1)", code: "+1" },
  { value: "LC", label: "Saint Lucia (+1)", code: "+1" },
  { value: "VC", label: "Saint Vincent and the Grenadines (+1)", code: "+1" },
  { value: "WS", label: "Samoa (+685)", code: "+685" },
  { value: "SM", label: "San Marino (+378)", code: "+378" },
  { value: "ST", label: "Sao Tome and Principe (+239)", code: "+239" },
  { value: "SA", label: "Saudi Arabia (+966)", code: "+966" },
  { value: "SN", label: "Senegal (+221)", code: "+221" },
  { value: "RS", label: "Serbia (+381)", code: "+381" },
  { value: "SC", label: "Seychelles (+248)", code: "+248" },
  { value: "SL", label: "Sierra Leone (+232)", code: "+232" },
  { value: "SG", label: "Singapore (+65)", code: "+65" },
  { value: "SK", label: "Slovakia (+421)", code: "+421" },
  { value: "SI", label: "Slovenia (+386)", code: "+386" },
  { value: "SB", label: "Solomon Islands (+677)", code: "+677" },
  { value: "SO", label: "Somalia (+252)", code: "+252" },
  { value: "ZA", label: "South Africa (+27)", code: "+27" },
  { value: "SS", label: "South Sudan (+211)", code: "+211" },
  { value: "ES", label: "Spain (+34)", code: "+34" },
  { value: "LK", label: "Sri Lanka (+94)", code: "+94" },
  { value: "SD", label: "Sudan (+249)", code: "+249" },
  { value: "SR", label: "Suriname (+597)", code: "+597" },
  { value: "SE", label: "Sweden (+46)", code: "+46" },
  { value: "CH", label: "Switzerland (+41)", code: "+41" },
  { value: "SY", label: "Syria (+963)", code: "+963" },
  { value: "TW", label: "Taiwan (+886)", code: "+886" },
  { value: "TJ", label: "Tajikistan (+992)", code: "+992" },
  { value: "TZ", label: "Tanzania (+255)", code: "+255" },
  { value: "TH", label: "Thailand (+66)", code: "+66" },
  { value: "TL", label: "Timor-Leste (+670)", code: "+670" },
  { value: "TG", label: "Togo (+228)", code: "+228" },
  { value: "TO", label: "Tonga (+676)", code: "+676" },
  { value: "TT", label: "Trinidad and Tobago (+1)", code: "+1" },
  { value: "TN", label: "Tunisia (+216)", code: "+216" },
  { value: "TR", label: "Turkey (+90)", code: "+90" },
  { value: "TM", label: "Turkmenistan (+993)", code: "+993" },
  { value: "TV", label: "Tuvalu (+688)", code: "+688" },
  { value: "UG", label: "Uganda (+256)", code: "+256" },
  { value: "UA", label: "Ukraine (+380)", code: "+380" },
  { value: "AE", label: "United Arab Emirates (+971)", code: "+971" },
  { value: "GB", label: "United Kingdom (+44)", code: "+44" },
  { value: "US", label: "United States (+1)", code: "+1" },
  { value: "UY", label: "Uruguay (+598)", code: "+598" },
  { value: "UZ", label: "Uzbekistan (+998)", code: "+998" },
  { value: "VU", label: "Vanuatu (+678)", code: "+678" },
  { value: "VA", label: "Vatican City (+379)", code: "+379" },
  { value: "VE", label: "Venezuela (+58)", code: "+58" },
  { value: "VN", label: "Vietnam (+84)", code: "+84" },
  { value: "YE", label: "Yemen (+967)", code: "+967" },
  { value: "ZM", label: "Zambia (+260)", code: "+260" },
  { value: "ZW", label: "Zimbabwe (+263)", code: "+263" },
];

export const countryOptions = countryCallingCodeOptions.map((option) => ({
  value: option.value,
  label: option.label.replace(/\s*\(\+\d+\)$/, ""),
}));
